/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDrayRate.ts                      *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/dray-rate";

export class AutogenModelDrayRate<RowType extends ModelRow> extends Endpoint<RowType, RowDrayRateFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDrayRate extends ModelRow<RowDrayRateFields> {
	constructor(values?: Partial<RowDrayRateFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDrayRateFields {
	company_id: string;
	effective_date: Date;
	expiration_date: Date;
	id: number;
}

